import { render, staticRenderFns } from "./safety.vue?vue&type=template&id=72276d62&scoped=true"
import script from "./safety.vue?vue&type=script&lang=js"
export * from "./safety.vue?vue&type=script&lang=js"
import style0 from "./safety.vue?vue&type=style&index=0&id=72276d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72276d62",
  null
  
)

export default component.exports